// Entity Type Options
export const ENTITY_TYPE_OPTIONS = [
  { value: 'PrivatelyHeldCorporation', label: 'Private Company (LLC, Corporation, Etc)' },
  { value: 'PubliclyTradedCorporation', label: 'Publicly Traded Corporation' },
  { value: 'Partnership', label: 'Partnership (General or Limited)' },
  { value: 'Trust', label: 'Trust or Estate' },
  { value: 'NotForProfitOrganization', label: 'Charity/Non-Profit' },
  { value: 'ReligiousOrganization', label: 'Religious Organization' },
  { value: 'GovernmentEntityOrAgency', label: 'Government Entity or Agency' },
  { value: 'DomesticFinancialInstitution', label: 'Financial Institution (Domestic)' },
  { value: 'ForeignFinancialInstitution', label: 'Financial Institution (Foreign)' }
];

// Source of Funds Options
export const SOURCE_OF_FUNDS_OPTIONS = [
  { value: 'SalesOfGoods', label: 'Sales of goods' },
  { value: 'SalesOfServices', label: 'Sales of services' },
  { value: 'CustomerPayments', label: 'Customer payments (invoices)' },
  { value: 'InvestmentCapital', label: 'Investment Capital' },
  { value: 'BusinessLoans', label: 'Business Loans' },
  { value: 'OwnerContributions', label: 'Owner Contributions' },
  { value: 'FranchiseRevenue', label: 'Franchise Revenue' },
  { value: 'RentalIncome', label: 'Rental Income' },
  { value: 'GovernmentContractsOrGrants', label: 'Government Contracts or Grants' },
  { value: 'DonationsOrFundraising', label: 'Donations or fundraising' },
  { value: 'MembershipFeesOrSubscriptions', label: 'Membership fees or subscriptions' },
  { value: 'LicensingOrRoyalties', label: 'Licensing or royalties' },
  { value: 'CommissionIncome', label: 'Commission income' },
  { value: 'ImportExportRevenue', label: 'Import/Export revenue' },
  { value: 'CryptocurrencyRelatedActivity', label: 'Cryptocurrency related activity' }
];

// Account Purpose Options
export const ACCOUNT_PURPOSE_OPTIONS = [
  { value: 'RetailSalesInPerson', label: 'Retail Sales (in-person)' },
  { value: 'EcommerceSales', label: 'E-Commerce Sales' },
  { value: 'CashHeavyIncomeAndOperations', label: 'Cash-Heavy Income and Operations' },
  { value: 'ImportExportTradeOperations', label: 'Import/Export Trade Operations' },
  {
    value: 'ProfessionalServicesNotHandlingFunds',
    label: 'Professional Services (not handling funds)'
  },
  {
    value: 'ProfessionalServicesHandlingFunds',
    label: 'Professional Services (handling funds)'
  },
  {
    value: 'HoldingOrInvestmentCompanyOperations',
    label: 'Holding or Investment Company Operations'
  },
  {
    value: 'PropertyManagementOrRealEstateOperations',
    label: 'Property Management or Real Estate Operations'
  },
  {
    value: 'CharitableOrNonProfitOrganizationOperations',
    label: 'Charitable or Non-Profit Organization Operations'
  },
  {
    value: 'ConstructionAndContractingOperations',
    label: 'Construction and Contracting Operations'
  },
  { value: 'CommercialCashOperations', label: 'Commercial Cash Operations' },
  {
    value: 'FreightForwardingOrLogisticsOperations',
    label: 'Freight Forwarding/Logistics Operations'
  },
  { value: 'ThirdPartyPaymentProcessing', label: 'Third Party Payment Processing' },
  { value: 'TechnologyStartupOperations', label: 'Technology Startup Operations' },
  { value: 'WholesaleDistributionOperations', label: 'Wholesale Distribution Operations' },
  { value: 'FranchiseOperationOperations', label: 'Franchise Operation Operations' },
  { value: 'HealthcareProviderOperations', label: 'Healthcare Provider Operations' },
  { value: 'EducationalInstitutionOperations', label: 'Educational Institution Operations' }
];

// Transaction Volume Options
export const TRANSACTION_VOLUME_OPTIONS = [
  { value: 'LessThan10K', label: 'Less than $10,000', description: '$0 - $10,000' },
  { value: 'Between10KAnd50K', label: '$10,000 - $50,000', description: '$10,000 - $50,000' },
  { value: 'Between50KAnd250K', label: '$50,001 - $250,000', description: '$50,000 - $250,000' },
  {
    value: 'Between250KAnd1M',
    label: '$250,001 - $1,000,000',
    description: '$250,000 - $1,000,000'
  },
  {
    value: 'Between1MAnd2M',
    label: '$1,000,001 - $2,000,000',
    description: '$1,000,000 - $2,000,000'
  },
  { value: 'GreaterThan2M', label: 'Over $2,000,000', description: '$2,000,000+' }
];

// US Nexus Options (values must match UsNexus enum in typeDefs.graphql)
export const US_NEXUS_OPTIONS = [
  { value: 'Employees', label: 'Employees' },
  { value: 'Customers', label: 'Customers' },
  { value: 'PhysicalOfficeOrFacility', label: 'Physical office or facility' },
  { value: 'BankingRelationships', label: 'Banking relationships' }
];

// Unit API free-text detail fields currently reject values over 255 characters.
export const UNIT_TEXT_DETAIL_MAX_LENGTH = 255;

// Per Unit V2 (REF: https://www.unit.co/docs/applications-v2/applications/), these enum
// values make the corresponding *Detail / *Description field conditionally required
// for BUSINESS applications. Used by the form's save-status gate to keep submission
// blocked until the conditional text is provided.
export const ACCOUNT_PURPOSES_REQUIRING_DETAIL = [
  'CashHeavyIncomeAndOperations',
  'ProfessionalServicesHandlingFunds',
  'CharitableOrNonProfitOrganizationOperations',
  'CommercialCashOperations',
  'ThirdPartyPaymentProcessing'
];

export const SOURCES_OF_FUNDS_REQUIRING_DESCRIPTION = [
  'GovernmentContractsOrGrants',
  'DonationsOrFundraising',
  'ImportExportRevenue'
];

export const TRANSACTION_VOLUMES_REQUIRING_DESCRIPTION = ['Between1MAnd2M', 'GreaterThan2M'];
